import { render, staticRenderFns } from "./XInput.vue?vue&type=template&id=3ba971c9&scoped=true&"
import script from "./XInput.vue?vue&type=script&lang=js&"
export * from "./XInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba971c9",
  null
  
)

export default component.exports